import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import {
  EUserPermission,
  EUserRole,
} from '@/hooks/usePermissions/permissions.type'
import { usePermissions } from '@/hooks/usePermissions/usePermissions'
import { useRedirectBasedOnPermissions } from '@/hooks/useRedirectBasedOnPermissions'
import { useListOfUseCasesQuery } from '@/store/api/RunReport/RunReport.query'
import {
  clearNewSearch,
  setIsPrefillForm,
} from '@/store/api/RunReport/RunReport.slice'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'
import {
  selectIsPending,
  selectItsDefaultState,
  selectWorkspaceCreditsFromStore,
} from '@/store/api/Users/Users.selector'

import { HomeReportsSection } from './components/HomeReportsSection/HomeReportsSection'
import { SearchSection } from './components/SearchSection/SearchSection'

export const Home = () => {
  const { hasPermission } = usePermissions()
  hasPermission(EUserPermission.HANDLE_REPORTS, EUserRole.TEAM_ANALYST)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
    data: userData,
    isError,
    isLoading,
  } = useUserInfoQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      data,
    }),
  })

  useEffect(() => {
    if (userData?.role === EUserRole.READER) {
      navigate(AppRoutes.reports)
    }
  }, [userData])

  const aiReportCredits =
    useSelector(selectWorkspaceCreditsFromStore)?.aiReportCredits ?? 0
  const aiAnalystReportCredits =
    useSelector(selectWorkspaceCreditsFromStore)?.aiAnalystReportCredits ?? 0
  const adverseMediaReportCredits =
    useSelector(selectWorkspaceCreditsFromStore)?.adverseMediaReportCredits ?? 0
  const assistedReportCredits =
    useSelector(selectWorkspaceCreditsFromStore)?.assistedReportCredits ?? 0
  const facialMatchingCredits =
    useSelector(selectWorkspaceCreditsFromStore)?.facialMatchingCredits ?? 0

  const isDefaultState = useSelector(selectItsDefaultState)

  const { hasHandleReports } = useRedirectBasedOnPermissions()

  const { isLoading: isLoadingUserData } = useUserInfoQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      isPending: selectIsPending(data),
    }),
  })

  const { isLoading: isLoadingUsesCasesData, isError: isErrorUseCasesData } =
    useListOfUseCasesQuery()

  useEffect(() => {
    dispatch(clearNewSearch())
    dispatch(setIsPrefillForm(false))
    if (!isDefaultState) {
      hasHandleReports()
    }
  }, [isLoadingUserData])

  return (
    <WeScreen
      isError={isError || isErrorUseCasesData}
      isLoading={isLoading || isLoadingUsesCasesData || isLoadingUserData}
      useHeader={false}
      contentClassName="p-6 gap-6 overflow-y-auto"
    >
      <div className="flex justify-center w-full">
        <SearchSection
          aiReportCredits={aiReportCredits}
          aiAnalystReportCredits={aiAnalystReportCredits}
          adverseMediaReportCredits={adverseMediaReportCredits}
          assistedReportCredits={assistedReportCredits}
          facialMatchingCredits={facialMatchingCredits}
        />
      </div>
      <div className="flex w-full justify-center md:min-h-0 md:flex-1">
        <HomeReportsSection />
      </div>
    </WeScreen>
  )
}
